import { Drawer, Text } from '@/components';
import { useUpsertExecutionItem } from '@/features/project/_hooks/execution-item';
import { useProject } from '@/features/project/_hooks/project';
import { useMessage } from '@/providers';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useProjectDetailDrawerState } from '../../_components/ProjectDrawerStateProvider';
import { UpsertPriorExecutionItemForm } from './UpsertPriorExecutionItemForm';

type Props = {
  priorProjectId: string;
};

export const UpsertPriorExecutionItemFormDrawer: FC<Props> = ({
  priorProjectId,
}) => {
  const { t } = useTranslation();
  const { openMessage } = useMessage();
  const { drawerState, setDrawerState } = useProjectDetailDrawerState();
  const project = useProject(priorProjectId);
  const { mutateAsync } = useUpsertExecutionItem();

  return (
    <Drawer
      open={drawerState.open && drawerState.type === 'prior-execution-item'}
      onClose={() => {
        setDrawerState({ open: false });
      }}
      destroyOnClose
    >
      {project.data?.subProjects[0]?.expenditureCarts ? (
        <UpsertPriorExecutionItemForm
          expenditureCarts={project.data.subProjects[0].expenditureCarts}
          onSubmit={async (values) => {
            try {
              await mutateAsync({
                ...values,
                projectId: priorProjectId,
                subProjectId: project.data.subProjects[0]?.id ?? '',
              });
              await Promise.all([
                openMessage('success', t('message-update-completed')),
                (async () => {
                  setDrawerState({ open: false });
                })(),
              ]);
            } catch {
              await openMessage('error', t('message-update-failed'));
            }
          }}
        />
      ) : (
        <Text text={t('message-no-available-expenditure-cart')} />
      )}
    </Drawer>
  );
};
